"use client";

// Inline language switcher: a compact segmented control (no dropdown, no
// popup). One click switches language — fewer interactions than a menu.
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { useI18n } from "@/lib/i18n/provider";
import { toast } from "sonner";

export function LanguageSwitcher() {
  const { locale, setLocale, locales, localeNames, t } = useI18n();
  return (
    <div
      className="flex items-center gap-0.5 rounded-md border px-0.5 py-0.5"
      role="group"
      aria-label={t("lang.label")}
    >
      <Globe className="mx-1 h-3.5 w-3.5 text-muted-foreground" />
      {locales.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => {
            if (l === locale) return;
            setLocale(l);
            toast.success(t("lang.changed"));
          }}
          aria-pressed={l === locale}
          title={localeNames[l]}
          className={`rounded px-1.5 py-0.5 text-[11px] font-semibold uppercase transition-colors ${
            l === locale
              ? "bg-foreground text-background"
              : "text-muted-foreground hover:bg-muted hover:text-foreground"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
